import { LegalLayout } from "@/components/LegalLayout";
import { RotateCcw } from "lucide-react";

const sections = [
  { heading: "Your right of withdrawal (EU)", body: (
    <p>If you are an <strong>EU/EEA customer</strong>, under the EU Consumer Rights Directive you may cancel most orders within <strong>14 days</strong> of receiving your goods, without giving any reason. Perishable food items, personalised products and opened hygiene or beauty products are excluded where permitted by law.</p>
  ) },
  { heading: "Your rights in Nigeria (FCCPA)", body: (
    <p>If you are a <strong>Nigerian customer</strong>, you are protected by the Federal Competition and Consumer Protection Act (FCCPA), enforced by the FCCPC. You are entitled to goods that are safe, of good quality and match their description, and to a repair, replacement or refund for defective or misrepresented items.</p>
  ) },
  { heading: "Condition of returned items", body: (
    <p>Items must be unused, in their original packaging and in a resalable condition. Please include your order reference so the seller can process your return quickly.</p>
  ) },
  { heading: "How to request a return", body: (
    <p>Open your <a className="text-primary underline underline-offset-2" href="/account">Account → Orders</a>, select the order and choose <em>Request return</em>. You can also raise a case through our <a className="text-primary underline underline-offset-2" href="/disputes">Disputes & Reports</a> portal if the item is faulty, damaged or not as described.</p>
  ) },
  { heading: "Refunds", body: (
    <p>Once the seller receives and inspects the returned item, approved refunds are issued to your original payment method within <strong>14 days</strong>. Shipping costs for faulty or incorrect items are refunded in full; for change-of-mind returns, return postage may be at your expense.</p>
  ) },
  { heading: "Faulty or not-as-described goods", body: (
    <p>If an item is defective or does not match its listing, you are entitled to a repair, replacement or full refund at no cost to you, under both EU consumer law and the Nigerian FCCPA. Report it within 30 days for the fastest resolution.</p>
  ) },
  { heading: "Governing law", body: (
    <p>Your statutory rights depend on where you live: <strong>EU/EEA customers</strong> are covered by the consumer-protection law of their country of residence; <strong>Nigerian customers</strong> are covered by Nigerian law (FCCPA). This policy does not limit any mandatory rights you have under those laws.</p>
  ) },
  { heading: "Need help?", body: (
    <p>Our team is here for you via the <a className="text-primary underline underline-offset-2" href="/customer-service">Customer Service</a> centre or the <a className="text-primary underline underline-offset-2" href="/contact">Contact</a> page.</p>
  ) },
];

export default function ReturnRefundPolicy() {
  return (
    <LegalLayout
      title="Return & Refund Policy"
      icon={RotateCcw}
      testid="return-refund-page"
      intro="Xurray Mart wants every purchase to delight you. This policy explains when and how you can return an item and receive a refund, in line with EU consumer-protection law and Nigeria's FCCPA."
      sections={sections}
    />
  );
}
